import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { Avatar, Box, Grid, MenuItem, Stack } from "@mui/material";
import {
  StyledButton,
  StyledContainer,
  StyledDropdown,
  StyledLogo,
  StyledBadge,
  StyledAvatar,
  StyledAvatarButton,
  AvatarBox
} from "./NavBar.styles";
import Button from "../shared/Button/Button";
import API from "api";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/Provider";
import Session from "../../helpers/session";
import SharedDrawer from "components/shared/Drawer/Drawer";
import theme from "helpers/mui-theme.helper";
import Details from "views/PatientBoard/microViews/Details/Details";
import Profile from "views/PatientBoard/microViews/Profile/Profile";
import { getLogo } from "./NavBarUtility";

export default function NavBar() {
  const [language, setLanguage] = useState<string>(
    `${localStorage.getItem("i18nextLng")}`
  );
  const [buttonState, setButtonState] = useState({
    details: "none",
    profile: "none"
  });
  const [loggedInClient, setLoggedInClient] = useState<any>();
  const { t } = useTranslation();
  const {
    config,
    configDispatch,
    notifications,
    providerDispatch,
    encounters,
    member,
    encounterDispatch
  } = useContext(GlobalContext);
  const decodedCookie = decodeURIComponent(document.cookie);
  const location = window.location.pathname.split("/")[1];
  const view = window.location.pathname.split("/")[2];

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLanguage(event.target.value);
    localStorage.setItem("i18nextLng", `${event.target.value}`);
    window.location.reload();
  };
  const handleButtonState = (origin: string) => {
    if (origin === "details") {
      setButtonState({
        ...buttonState,
        details: buttonState.details === "block" ? "none" : "block"
      });
    } else if (origin === "profile") {
      setButtonState({
        ...buttonState,
        profile: buttonState.profile === "block" ? "none" : "block"
      });
    }
  };
  const handleLogout = () => {
    const isProvider = window.location.pathname.split("/")[1] === "provider";
    if (isProvider) {
      document.cookie =
        "life365_provider" +
        "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    document.cookie =
      "life365_session" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    window.location.pathname = "/";
  };

  const coordinatorInitialsGenerator = (origin: string) => {
    const initials = Session.crackCookieUsername(origin).split(" ");
    return initials[0] !== ""
      ? `${initials[0][0].toUpperCase()}${
          initials[1] ? initials[1][0].toUpperCase() : ""
        }`
      : "";
  };

  const generateLoggedClient = () => {
    if (decodedCookie.includes("life365_session")) {
      API.kore.coordinator
        .getSingle(
          Session.crackCookieUserId("coordinator"),
          Session.crackCookieToken("coordinator")
        )
        .then((res) => {
          setLoggedInClient(res);
          providerDispatch({ type: "UPDATE_LOGGED_IN_CLIENT", payload: res });
        });
    } else if (decodedCookie.includes("life365_provider")) {
      API.kore.coordinator
        .getSingle(
          Session.crackCookieUserId("provider"),
          Session.crackCookieToken("provider")
        )
        .then((res) => {
          setLoggedInClient(res);
          providerDispatch({ type: "UPDATE_LOGGED_IN_CLIENT", payload: res });
        });
    }
  };

  useEffect(() => {
    generateLoggedClient();
    configDispatch({
      type: "COORD_IN",
      payload: decodedCookie.includes("life365_session")
    });
    configDispatch({
      type: "PROVIDER_IN",
      payload: decodedCookie.includes("life365_provider")
    });
  }, []);

  const icon = (
    <StyledAvatar>{coordinatorInitialsGenerator(location)}</StyledAvatar>
  );
  // need to modify whats shown in this component
  const menuItems = (
    <div>
      <Box pt={1}>
        {/* <AvatarBox>
          <Button
            variant="info"
            onClick={() => {
              handleButtonState("profile");
            }}
            width={
              buttonState.details === "none" && buttonState.profile === "none"
                ? theme.spacing(25)
                : theme.spacing(93)
            }
          >
            Profile
          </Button>
        </AvatarBox> */}
        {/* <AvatarBox sx={{ display: buttonState.profile }}>
            <Profile type={"coordinator"} action="edit" isAvatar={true} />
        </AvatarBox> */}
        <AvatarBox>
          <Button
            variant="primary"
            onClick={handleLogout}
            width={
              buttonState.details === "none" && buttonState.profile === "none"
                ? theme.spacing(25)
                : theme.spacing(93)
            }
          >
            {t("u-logout")}
          </Button>
        </AvatarBox>
      </Box>
      <StyledDropdown
        value={language}
        // @ts-ignore
        onChange={handleChange}
        displayEmpty
        size={"small"}
        variant={"filled"}
        sx={{
          width:
            buttonState.details === "none" && buttonState.profile === "none"
              ? theme.spacing(25)
              : theme.spacing(90)
        }}
      >
        <MenuItem value={"en"}>English</MenuItem>
        <MenuItem value={"es"}>Español</MenuItem>
        <MenuItem value={"fr"}>Français</MenuItem>
      </StyledDropdown>
    </div>
  );
  return (
    <StyledContainer container>
      <Grid item xs={1} sm={1} />
      <Grid item xs={6} sm={6}>
        <StyledLogo src={getLogo()} />
        <br />
        {location !== "provider" &&
          location !== "admin" &&
          config?.coordLogin && (
            <div>
              <StyledButton to="/">{t("u-members")}</StyledButton>
              <StyledButton to="/notifications">
                <StyledBadge
                  badgeContent={notifications?.itemsCount}
                  color={"warning"}
                >
                  {t("u-notifications")}
                </StyledBadge>
              </StyledButton>
            </div>
          )}
        {location === "provider" && config?.providerLogin && (
          <div>
            <StyledButton
              //@ts-ignore
              selectedButton={
                view === "coordinators" || view === "members" ? true : false
              }
              to="/provider/coordinators"
            >
              {t("u-users")}
            </StyledButton>
            {/* <StyledButton to="/provider/managers">{t('u-managers')}</StyledButton> */}

            <StyledButton
              //@ts-ignore
              selectedButton={view === "reports" ? true : false}
              to="/provider/reports"
            >
              {t("u-reports")}
            </StyledButton>

            <StyledButton
              //@ts-ignore
              selectedButton={view === "configurations" ? true : false}
              to="/provider/configurations"
            >
              {t("u-configurations")}
            </StyledButton>
            <StyledButton
              //@ts-ignore
              selectedButton={view === "global" ? true : false}
              to="/provider/global/thresholds"
            >
              {'Global Thresholds'}
            </StyledButton>
            {config?.orderOptions.newMember !== "none" ? (
              <StyledButton to="/provider/orders">{t("u-orders")}</StyledButton>
            ) : (
              ""
            )}
          </div>
        )}
      </Grid>
      <Grid item sm={1.5} lg={2.5}></Grid>
      <Grid item sm={2.5} lg={1.5}>
        <Stack spacing={2} sx={{ paddingLeft: 10 }}>
          {((location !== "login" &&
            location !== "provider" &&
            config?.coordLogin) ||
            (location === "provider" && config?.providerLogin)) && (
            <SharedDrawer icon={icon} menuItems={menuItems} origin={"navBar"} />
          )}
        </Stack>
      </Grid>
      <Grid item sm={1}></Grid>
    </StyledContainer>
  );
}
